import { call, put } from 'redux-saga/effects';
import { FRONT_URL } from '../../../configs';
import { authorizedLoginFailed, authorizedESIALogoutSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import processError from '../../../utils/processError';

export default function* authorizedESIALogout(action) {
  try {
    if (window.updateTimers && window.updateTimers.length) {
      for (let i = 0, len = window.updateTimers.length; i < len; i++) {
        clearTimeout(window.updateTimers[i]);
      }
    }
    const logout = yield window.keycloak.logout({ redirectUri: FRONT_URL });
    yield put(authorizedESIALogoutSuccessful());
    yield call(resolveActionPromise(action));
  } catch (e) {
    yield put(authorizedLoginFailed());
    yield processError(e);
  }
}
